// Module
var code = `<miscellaneous-transactions-page header-title="\$ctrl.header" form-title="\$ctrl.header | uppercase">
  <form name="\$ctrl.form" novalidate>
    <table class="table table--generate-row-ids">
      <tbody>
      <tr>
        <td></td>
        <td>{{'NUMBER_INPUT' | translate:'MISC_TRANSACTION'}}</td>
        <td>
          <input
            type="text"
            ng-model="\$ctrl.transaction.number"
            required/>
        </td>
      </tr>
      <tr ng-if="!\$ctrl.interbranch">
        <td></td>
        <td>Pay to the order of</td>
        <td>
          <input
              type="text"
              ng-model="\$ctrl.transaction.payee"
              required />
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Total amount:</td>
        <td>
          <cash value="\$ctrl.transactionAmount" ng-disabled="true"></cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Category:</td>
        <td>
          <gl-category-select
            required
            action-type="\$ctrl.interbranch ? 'CREATE_INTERBRANCH_CASHIER_CHECK' : 'CASHIER_CHECK_CREATION'"
            is-selectize="true"
            ng-model="\$ctrl.category"
            single-accounts-only = "false"
            ng-change="\$ctrl.updateCategoryUnits()"
        >
          </gl-category-select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Tax category:</td>
        <td>
          <gl-category-select
            required
            action-type="'CREATE_CASHIER_CHECK_TAX'"
            ng-model="\$ctrl.taxCategory"
            single-accounts-only = "false"
            ng-change="\$ctrl.updateTaxCategoryUnits()"
            is-selectize="true"
        >
          </gl-category-select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.interbranch">
        <td></td>
        <td>Target branches:</td>
        <td>
          <selectize
              class="nx-selectize"
              config="\$ctrl.branchSelectConfig"
              options="\$ctrl.otherBranches"
              ng-model="\$ctrl.targetBranches"
              ng-change="\$ctrl.branchChanged()"
              ng-required="true">
          </selectize>
        </td>
      </tr>
      </tbody>
    </table>

    <table class="create-cashiers-check__units-table table table--generate-row-ids">
      <thead>
      <tr>
        <th>Nr.</th>
        <th ng-if="\$ctrl.interbranch">Target branch</th>
        <th>Account</th>
        <th>Debit amount</th>
        <th>Credit amount</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td></td>
        <td ng-if="\$ctrl.interbranch">
          <input
            disabled
            type="text"
            ng-value="\$ctrl.currentBranch.name" />
        </td>
        <td>
          <select disabled>
            <option>{{ 'CASHIER_CHECK' | translateEnum:'LABEL' }}</option>
          </select>
        </td>
        <td>
          <cash ng-disabled="true"></cash>
        </td>
        <td>
          <cash value="\$ctrl.cashiersCheckAmount"
                ng-disabled="true"></cash>
        </td>
        <td></td>
      </tr>
      <tr ng-repeat="unit in \$ctrl.transaction.taxUnits.units">
        <td></td>
        <td ng-if="\$ctrl.interbranch">
          <input
            disabled
            type="text"
            ng-value="\$ctrl.currentBranch.name" />
        </td>
        <td>
          <select disabled>
            <option>{{unit.fullCode}}</option>
          </select>
        </td>
        <td>
          <cash ng-disabled="true"></cash>
        </td>
        <td>
          <cash ng-model="unit.amount" ng-required="true" ng-change="\$ctrl.updateAmount()"></cash>
        </td>
        <td></td>
      </tr>
      <tr ng-repeat="unit in \$ctrl.transaction.branchUnits">
        <td></td>
        <td ng-if="\$ctrl.interbranch">
          <input
              disabled
              type="text"
              ng-value="\$ctrl.getBranchName(unit.targetBranchId)" />
        </td>
        <td>
          <input
              disabled
              type="text"
              ng-value="unit.fullCode" />
        </td>
        <td>
          <cash ng-required="true"
                ng-model="unit.amount"
                ng-change="\$ctrl.updateAmount()"
          ></cash>
        </td>
        <td>
          <cash ng-disabled="true"></cash>
        </td>
        <td></td>
      </tr>
      </tbody>
    </table>

    <div ng-if="\$ctrl.transaction.branchUnits.length === 0">
      <validator condition="false"></validator>

      <div class="alert alert--danger" >
        Transaction units are required.
      </div>

    </div>
    <div ng-if="\$ctrl.cashiersCheckAmount <= 0">
      <div class="alert alert--danger" >
        Negative or zero transaction amount.
      </div>
    </div>
    <table class="table">
      <tbody>
        <tr>
          <td><strong>Remarks:</strong></td>
          <td>
            <input
              required
              type="text"
              class="add-account__remarks-input"
              ng-model="\$ctrl.transaction.remarks"/>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="summary-actions">
      <button
        type="button"
        class="btn btn-warning"
        ng-click="\$ctrl.cancelChanges()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        ng-disabled="\$ctrl.form.\$invalid || \$ctrl.cashiersCheckAmount <= 0"
        ng-click="\$ctrl.save()">
        Transfer now
      </button>
    </div>
  </form>
</miscellaneous-transactions-page>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/create-cashiers-check/create-cashiers-check.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;